"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var common_tags_1 = require("common-tags");
var element_1 = require("../element");
var geometry_1 = require("../geometry");
var tool = require("../tool");
/**
 * Test if the first node precedes the second one. true is returned only if they are
 * at the same level. Pass undefined as the second selection to test if the first one
 * is the last node.
 */
function precedes(first, last) {
    if (last === undefined) {
        return !first.node().nextSibling;
    }
    return first.node().compareDocumentPosition(last.node()) === Node.DOCUMENT_POSITION_PRECEDING;
}
/** Insert nodes in selection a before the first node in selection b. */
function moveToBefore(a, b) {
    var bNodes = b ? b.nodes() : null;
    a.nodes().forEach(function (node) {
        var bFirstNode = b ? bNodes.find(function (n) { return n.parentElement === node.parentElement; }) : null;
        node.parentElement.insertBefore(node, bFirstNode);
    });
}
function positionOffsetedByAnchor(bound, anchor) {
    var x;
    var y;
    if (anchor & 16 /* Left */) {
        x = bound.x;
    }
    else if (anchor & 32 /* Center */) {
        x = bound.x - bound.width / 2;
    }
    else if (anchor & 64 /* Right */) {
        x = bound.x - bound.width;
    }
    if (anchor & 2 /* Top */) {
        y = bound.y;
    }
    else if (anchor & 4 /* Middle */) {
        y = bound.y - bound.height / 2;
    }
    else if (anchor & 8 /* Bottom */) {
        y = bound.y - bound.height;
    }
    return { x: x, y: y };
}
exports.positionOffsetedByAnchor = positionOffsetedByAnchor;
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        var _this = _super.call(this) || this;
        _this.needCustomUpdate = false;
        _this._layouted = false;
        _this.elements = [];
        _this._options._anchor = 16 /* Left */ | 2 /* Top */;
        _this._options._width = geometry_1.GeometryValue.fullSize;
        _this._options._height = 0;
        _this._options._disableDynamicSize = false;
        _this._options._dynamicSizeGetter = null;
        _this.init();
        return _this;
    }
    Component.attributeForTagContent = function () {
        return null;
    };
    Component.parseAttributeValue = function (attr, value) {
        switch (attr) {
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    // tslint:disable-next-line
    Component.prototype.init = function () { };
    Component.prototype.appendGroupT = function (ctor) {
        var element = new ctor(this);
        this.elements.push(element);
        element.parent = this;
        element._isEnterAppend = true;
        return element;
    };
    Component.prototype.appendT = function (ctor) {
        var element = new ctor(this);
        this.elements.push(element);
        element.parent = this;
        element._isEnterAppend = false;
        return element;
    };
    Component.prototype._append = function (element, isGroup) {
        if (isGroup === void 0) { isGroup = false; }
        element.parent = this;
        this.elements.push(element);
        element._isEnterAppend = isGroup;
        return element;
    };
    Component.prototype.reset = function () {
        _super.prototype.reset.call(this);
        this._removeBrush();
    };
    Component.prototype.removeAllElements = function () {
        for (var _a = 0, _b = this.elements; _a < _b.length; _a++) {
            var element = _b[_a];
            element.remove();
        }
        this.elements = [];
    };
    // tslint:disable-next-line
    Component.prototype.customAppend = function () { };
    // tslint:disable-next-line
    Component.prototype.customRender = function () { };
    Component.prototype.layoutSubTree = function () {
        var _this = this;
        this.__stopRender = false;
        var pendingSubtrees = [];
        var finishedSubtrees = new Set();
        if (this._layouted) {
            return;
        }
        this.setup();
        if (this.noNeedToRender) {
            return;
        }
        this.computeFixedSize();
        if (this.hasFixedSize || this.hasFlexibleSize) {
            this.prepare();
        }
        this.applyAll(function (el) {
            if (el === _this) {
                return;
            }
            el.__stopRender = false;
            if ((el.__stopRender || el.hasFixedSize)) {
                el.__stopRender = true;
                pendingSubtrees.push(el);
                return true;
            }
        }, false);
        this.applyAll(function (el) {
            if (el === _this) {
                return;
            }
            if (el.__stopRender) {
                return true;
            }
            if (el.hasFlexibleSize && el instanceof Component) {
                el.layoutSubTree();
                el.__stopRender = true;
                finishedSubtrees.add(el);
                return true;
            }
            el.setup();
            if (el instanceof Component && !el.noNeedToRender) {
                el.computeFixedSize();
            }
        }, false);
        this.computeIntrinsicSize();
        this.computeExtrinsicSize();
        this.computeIntrinsicSize(true);
        this.computeExtrinsicSize(true);
        this.applyAll(function (el) {
            if (el === _this && (el.hasFixedSize || el.hasFlexibleSize)) {
                return;
            }
            if (finishedSubtrees.has(el)) {
                return true;
            }
            if (el.__stopRender || el.noNeedToRender) {
                return true;
            }
            el.prepare();
        });
        pendingSubtrees.forEach(function (tree) { return tree.layoutSubTree(); });
        this._layouted = true;
    };
    Component.prototype.computeIntrinsicSize = function (fix) {
        var _this = this;
        if (fix === void 0) { fix = false; }
        if (this.noNeedToRender || this.__stopRender) {
            return;
        }
        _super.prototype.computeIntrinsicSize.call(this);
        this.elements.forEach(function (el) { return el.computeIntrinsicSize(); });
        if (this.hasFixedSize || this.hasFlexibleSize) {
            return;
        }
        this.domEach(function (d, _i, g, i) {
            ["width", "height"].forEach(function (op) {
                var geo = _this._cachedGeometry[i][op];
                if (geo._auto /* || geo.unit === GeometryUnit.Percent*/) {
                    var contentSize = _.max(_this.elements
                        .filter(function (x) { return !x.hasAbsolutePosition; })
                        .map(function (x) { return x.maxIntrinsicSize(op === "width", fix); }));
                    _this._intrinsicSize[i][op] = contentSize;
                    return;
                }
            });
        });
    };
    Component.prototype.computeExtrinsicSize = function (fix) {
        if (fix === void 0) { fix = false; }
        if (this.noNeedToRender || this.__stopRender) {
            return;
        }
        _super.prototype.computeExtrinsicSize.call(this);
        this.elements.forEach(function (el) {
            el.computeExtrinsicSize();
        });
    };
    Component.prototype.computeFixedSize = function () {
        _super.prototype.computeIntrinsicSize.call(this);
        _super.prototype.computeExtrinsicSize.call(this);
    };
    Component.prototype.findFixedParent = function () {
        if (this.hasFixedSize || !this.parent) {
            return this;
        }
        return this.parent.findFixedParent();
    };
    Component.prototype.render = function (isRoot) {
        var _this = this;
        if (isRoot === void 0) { isRoot = true; }
        var ids = [];
        for (var _a = 1; _a < arguments.length; _a++) {
            ids[_a - 1] = arguments[_a];
        }
        if (isRoot) {
            if (this._rendered && !this.hasAbsolutePosition) {
                var parent_1 = this.findFixedParent();
                if (parent_1 === this) {
                    parent_1.applyAll(function (el) { return el._resetSize(); });
                }
                else {
                    parent_1.render(true);
                    return;
                }
            }
            this.layoutSubTree();
        }
        if (!this._preRender()) {
            return;
        }
        this.setTransform();
        this._render();
        if (ids && ids.length > 0) {
            if (ids.length === 1 && ids[0] === "_") {
                return;
            }
            var splittedIds_1 = ids.map(function (id) { return _.split(id, ".", 2); });
            this.elements.forEach(function (e) {
                splittedIds_1.forEach(function (gp) {
                    if (gp[0] === e.id) {
                        if (typeof gp[1] === "string") {
                            e.render.call(_this, false, gp[1]);
                        }
                        else {
                            e.render(false);
                        }
                    }
                });
            });
        }
        else {
            this.elements.forEach(function (e) { e.render(false); });
        }
        if (isRoot) {
            this._adjustChildrenPosition();
        }
        this._postRender();
    };
    Component.prototype.postRender = function () {
        _super.prototype.postRender.call(this);
        this._setupClipPath();
        this._setupBrush();
    };
    Component.prototype._adjustChildrenPosition = function () {
        var lastDOM;
        for (var i = this.elements.length - 1; i >= 0; i--) {
            var curr = this.elements[i];
            if (!curr.dom || curr.dom.empty() || curr.noNeedToRender) {
                continue;
            }
            if (curr instanceof Component) {
                curr._adjustChildrenPosition();
            }
            if (!precedes(curr.dom, lastDOM)) {
                moveToBefore(curr.dom, lastDOM);
            }
            lastDOM = curr.dom;
        }
        if (this._brushDOM) {
            moveToBefore(this._brushDOM, null);
        }
    };
    Component.prototype._resetSize = function () {
        _super.prototype._resetSize.call(this);
        this._layouted = false;
        if (this.dom) {
            this.dom.attr("transform", "");
        }
    };
    Component.prototype._setupClipPath = function () {
        var _this = this;
        if (!this._options._clipPath) {
            return;
        }
        this._callRender(function (node, d, i, g, h) {
            var path = h.op("_clipPath");
            if (typeof path !== "string") {
                console.error("The clip path must be a string!");
            }
            var clipPathId = _this._uuid + "-" + i;
            var clipPath;
            if (path.startsWith("bound")) {
                var size = _this.computedSize(g[i]);
                var s = path.split(":");
                for (var i_1 = 1; i_1 <= 3; i_1++) {
                    var value = parseFloat(s[i_1]);
                    s[i_1] = isNaN(value) ? 0 : value;
                }
                var inset = s[3];
                clipPath = common_tags_1.oneLineTrim(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    <rect x=\"", "\" y=\"", "\"\n                        width=\"", "\" height=\"", "\"\n                        rx=\"", "\" ry=\"", "\">"], ["\n                    <rect x=\"", "\" y=\"", "\"\n                        width=\"", "\" height=\"", "\"\n                        rx=\"", "\" ry=\"", "\">"])), -inset, -inset, size.width + inset * 2, size.height + inset * 2, s[1], s[2]);
            }
            else {
                clipPath = path;
            }
            var def = _this.$visualizer.appendDef("clipPath", clipPathId);
            def.html(clipPath);
            node.attr("clip-path", "url(#" + clipPathId + ")");
        });
    };
    Component.prototype._setupBrush = function () {
        var _this = this;
        if (!this._options._brush || !this._isDirty("_brush")) {
            return;
        }
        if (this._isEnterAppend) {
            console.error("The _brush option doesn't support grouped elements!");
            return;
        }
        if (this._brush) {
            this._removeBrush(true);
        }
        var opt = this._options._brush;
        switch (opt.direction) {
            case "x":
                this._brush = d3.brushX();
                break;
            case "y":
                this._brush = d3.brushY();
                break;
            case "xy":
                this._brush = d3.brush();
                break;
        }
        var size = this.computedSize();
        this._brush.extent([[0, 0], [size.width, size.height]]);
        this._brushDOM = this.dom.append("g").classed("bvd3-brush", true);
        this._brushDOM.call(this._brush);
        if (!this._brushScale) {
            if (opt.scale) {
                this._brushScale = opt.scale.copy();
            }
            else {
                this._brushScale = d3.scaleLinear();
            }
            this._brush.move(this._brushDOM, this._brushScale.range());
        }
        if (opt.endCallback) {
            this._brush.on("end", function (d, i, g) {
                if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") {
                    return;
                }
                var range = d3.event.selection.map(_this._brushScale.invert, _this._brushScale);
                opt.endCallback.call(_this, { range: range, d: d, i: i, g: g });
            });
        }
        if (opt.brushCallback) {
            this._brush.on("brush", function (d, i, g) {
                if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") {
                    return;
                }
                var range = d3.event.selection.map(_this._brushScale.invert, _this._brushScale);
                opt.brushCallback.call(_this, { range: range, d: d, i: i, g: g });
            });
        }
    };
    Component.prototype._removeBrush = function (removeDOM) {
        if (removeDOM === void 0) { removeDOM = false; }
        if (!this._brush) {
            return;
        }
        this._brush.on("end", null);
        this._brush.on("brush", null);
        if (removeDOM) {
            // this._brushDOM.call(this._brush.move, null);
            this._brushDOM.remove();
        }
        this._brushScale = null;
        this._brush = null;
    };
    Component.prototype.brushMove = function (range) {
        this._brushDOM.call(this._brush.move, range);
    };
    Component.prototype.markAllDirty = function (ids) {
        this.markDirty(ids);
        this.elements.forEach(function (e) {
            if (e instanceof Component) {
                e.markAllDirty(ids);
            }
            else {
                e.markDirty(ids);
            }
        });
        return this;
    };
    Component.prototype.renderElement = function (node, d, i, g, h) {
        var _this = this;
        if (this._isDirty("class")) {
            var htmlClass = h.op("class");
            if (typeof htmlClass !== "undefined") {
                htmlClass.split(" ").forEach(function (cls) {
                    node.classed(cls, true);
                });
            }
        }
        ["visibility", "opacity", "cursor", "style"].forEach(function (attr) {
            if (_this._isDirty(attr)) {
                node.attr(attr, h.op(attr));
            }
        });
        if (this._isDirty("_html")) {
            node.html(h.op("_html"));
        }
    };
    /**
     * Setup a proxy element.
     * @param def An object which keys should be role names and values are how to deal with the proxy element.
     *            If the value is a function, it will be called with the proxy element as the only argument;
     *            If the value is a string, the framework will try to find the instance member with the same name
     *            and try to set options obtained from the proxy element for it.
     */
    Component.prototype.setupProxy = function (def, self) {
        var _this = this;
        if (self === void 0) { self = this; }
        this.elements.forEach(function (el) {
            var action = def[el.getRole()];
            if (typeof action === "function") {
                action.call(_this, el);
            }
            else if (typeof action === "string") {
                var element = self[action];
                if (element instanceof element_1.PrototypeElement && el instanceof Proxy) {
                    element.options(el.getAllOptions());
                }
            }
        });
    };
    Component.prototype.addProxy = function (role, options) {
        this.appendT(Proxy).options(__assign({ _role: role }, options));
        return this;
    };
    Component.prototype.setTransform = function () {
        var _this = this;
        this._callRender(function (self, d, i, g, h) {
            var bound = _this.computedSize(g[i], true);
            var anchor = h.op("_anchor");
            var _a = positionOffsetedByAnchor(bound, anchor), x = _a.x, y = _a.y;
            var rotation = "";
            if (_this._options._rotation) {
                var r = h.op("_rotation");
                rotation = tool.rotateWithOrigin.apply(_this, r);
            }
            var currTransform = self.attr("transform") || "";
            var rotateAfterTranslate = _this._options._rotateAfterTranslate !== undefined ? h.op("_rotateAfterTranslate") : true;
            self.attr("transform", rotateAfterTranslate ?
                tool.translate(x, y) + " " + currTransform + " " + rotation :
                rotation + " " + tool.translate(x, y) + " " + currTransform);
        });
    };
    Component.prototype.setDynamicSize = function (size) {
        var _this = this;
        Object.keys(size)
            .forEach(function (k) { return _this._intrinsicSize[0][k] = _this._computedSize[0][k] = size[k]; });
    };
    Component.prototype.computedSize = function (node, forceRefresh) {
        if (node === void 0) { node = null; }
        if (forceRefresh === void 0) { forceRefresh = false; }
        return this._computedSize[node ? this.dom.nodes().indexOf(node) : 0];
    };
    Component.prototype.pointFromAnchor = function (anchor, node) {
        var bounds = this.computedSize(node);
        var _a = positionOffsetedByAnchor({ x: 0, y: 0, width: bounds.width, height: bounds.height }, anchor), x = _a.x, y = _a.y;
        return { x: -x, y: -y };
    };
    Object.defineProperty(Component.prototype, "__tree__", {
        get: function () {
            var _this = this;
            var tree = this.__info__ + "\n";
            this.elements.forEach(function (el, i) {
                var _a = i === _this.elements.length - 1 ? ["└─", "  "] : ["├─", "│ "], t1 = _a[0], t2 = _a[1];
                tree += el.__tree__.split("\n").filter(function (l) { return l; })
                    .map(function (l, i) { return "" + (i === 0 ? t1 : t2) + l; }).join("\n") + "\n";
            });
            return tree;
        },
        enumerable: true,
        configurable: true
    });
    Component.nodeName = "g";
    return Component;
}(element_1.PrototypeElement));
exports.Component = Component;
var VirtualElement = /** @class */ (function (_super) {
    __extends(VirtualElement, _super);
    function VirtualElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VirtualElement.prototype.setup = function () { this.noNeedToRender = true; return; };
    VirtualElement.prototype.prepare = function () { return; };
    VirtualElement.prototype.render = function () { return; };
    VirtualElement.prototype.renderElement = function () { return; };
    VirtualElement.prototype.enterAppendSelf = function () { return; };
    VirtualElement.prototype.appendSelf = function () { return; };
    VirtualElement.prototype.markAllDirty = function (ids) { return this; };
    return VirtualElement;
}(Component));
exports.VirtualElement = VirtualElement;
var Proxy = /** @class */ (function (_super) {
    __extends(Proxy, _super);
    function Proxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filteredOptions = ["_type", "_isGroup", "_role"];
        return _this;
    }
    /** role:string */
    Proxy.initializeFromTemplate = function (obj, role) {
        obj._role = role;
    };
    Proxy.prototype.init = function () {
        _super.prototype.init.call(this);
        this._options = {};
    };
    Proxy.prototype.getAllOptions = function () {
        var _this = this;
        var keys = Array.from(this._dirtyOptions).filter(function (x) { return _this.filteredOptions.indexOf(x) < 0; });
        var result = {};
        keys.forEach(function (k) { return result[k] = _this._options[k]; });
        return result;
    };
    return Proxy;
}(VirtualElement));
exports.Proxy = Proxy;
var templateObject_1;
//# sourceMappingURL=component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/component.js
// module id = 80
// module chunks = 0 1